<template>
  <div id="job-student-notation">
    <div class="student" @click="openStudentModal(false, false)">
      <SingleAvatarStudent
        v-if="student"
        :picture="student.mainPicture ? student.mainPicture : null"
        size="60px"
        :first-name="student.firstName"
        :short-name="student.shortName"
        font-size="16px"
        :gender="student.gender"
      />
      <div class="name">
        {{ student.firstName }} {{ student.lastName.slice(0,1) }}.
        <span v-if="student.leader === false">{{ student.phone ? student.phone : '----' }}</span>
        <span v-if="student.leader === true" class="referer">{{ student.phone ? student.phone : '----' }}
          <el-tooltip
            effect="dark"
            content="Referent"
            :show-after="300"
            placement="bottom"
            :show-arrow="false"
          >
            <span class="referer-picto item">R</span>
          </el-tooltip>
        </span>

      </div>
    </div>
    <div class="notation" @click="openStudentModal(true, false)">
      <el-rate
        v-model="rating"
        void-icon="StarFilled"
        @change="studentRating(rating)"
      />
      <span class="rate-comment">{{ formatRating(rating) }}</span>
    </div>
    <div
      v-if="student && student.softSkillsRatedByCustomer && student.softSkillsRatedByCustomer.length !== 0"
      class="softskills"
      @click="openStudentModal(true, true)"
    >
      <el-tooltip
        effect="dark"
        :content="getSoftSkillsNames(student.softSkillsRatedByCustomer)"
        placement="top"
        :show-arrow="false"
      >
        <div class="with-rating item">
          <span class="sub-icon-text" :class="{ warning: rating === 3 || rating === 2 || rating === 1 }"> {{ student.softSkillsRatedByCustomer[0].name }}</span>
          <span
            v-if="student.softSkillsRatedByCustomer[1]"
            class="sub-icon-text"
            :class="{ warning: rating === 3 || rating === 2 || rating === 1 }"
          >{{ student.softSkillsRatedByCustomer[1].name }}</span>
          <span
            v-if="student.softSkillsRatedByCustomer[2]"
            class="sub-icon-text"
            :class="{ warning: rating === 3 || rating === 2 || rating === 1 }"
          >+{{ student.softSkillsRatedByCustomer.length - 2 }} <i class="fa fa-info-circle"/></span>
        </div>
      </el-tooltip>
    </div>

    <StudentModal
      :current-student="student"
      :modal-visible="studentDialogVisible"
      :edited="hasRatingChanged"
      :note="rating"
      :token="token"
      :preload-soft-skills="preloadSoftSkills"
      @close-modal="closeStudentModal"
      @feedback-saved="updateFeedback"
      @revert-list="revertFeedback"
    />
  </div>
</template>

<script>
import SingleAvatarStudent from '@/components/MyStudents/SingleAvatarStudent';
import StudentModal from '../MyStudents/StudentModal';

export default {
  components: {
    StudentModal,
    SingleAvatarStudent,
  },
  props: ['student', 'job', 'token'],
  data() {
    return {
      rating: 0,
      initialRating: 0,
      studentDialogVisible: false,
      hasRatingChanged: false,
      preloadSoftSkills: false,

    };
  },
  mounted() {
    if (this.student.feedbackScoreForCurrentCustomer) {
      this.rating = this.student.feedbackScoreForCurrentCustomer;
      this.initialRating = this.rating;
      this.$forceUpdate();
    }
  },
  methods: {
    formatRating(rate) {
      rate = parseInt(rate, 10);
      switch (rate) {
        case 0:
          return 'Ajouter une note';
        case 1:
          return 'Mauvaise attitude';
        case 2:
          return 'On ne veut plus';
        case 3:
          return 'On évite';
        case 4:
          return 'On aime';
        case 5:
          return 'Top priorité';
        default:
      }
      return rate;
    },

    openStudentModal(openSoftskills, preloadSoftSkills) {
      this.preloadSoftSkills = preloadSoftSkills;
      if (this.student.feedbackScoreForCurrentCustomer && this.student.feedbackScoreForCurrentCustomer === this.rating) {
        this.hasRatingChanged = false;
        this.preloadSoftSkills = true;
      }

      if (openSoftskills) {
        this.hasRatingChanged = true;
      }
      this.studentDialogVisible = true;
    },
    closeStudentModal() {
      this.studentDialogVisible = false;
    },
    updateFeedback(feedback, newNote) {
      this.student.softSkillsRatedByCustomer = feedback;
      this.rating = newNote;
      this.initialRating = this.rating;
    },
    revertFeedback() {
      if (this.initialRating > 0) {
        this.rating = this.initialRating;
      }
    },
    studentRating(rate) {
      this.$mixpanel.track('Notation Student', { From: 'From Landing Page', 'New Note': rate, 'Old Note': this.rating });
      this.rating = rate;
      this.hasRatingChanged = true;
      this.openStudentModal(false, false);
    },
    getSoftSkillsNames(softSkills) {
      return softSkills.reduce((acc, softSkill) => {
        acc.push(softSkill.name);
        return acc;
      }, []).join(', ');
    },
  },
};
</script>

<style scoped="scoped">
</style>
